import React, { Component } from 'react';
import __ from 'lodash';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import { Button,Row, Col, Alert} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import history from '../../../../history';
import LearningContentReq from '../../../../entity/LearningContentReq'
import './style.css';

class ViewKonten extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            data: props.location.state,
            tipeKonten: props.match.params.tipe,
            soals: [],
            materi: {},
            video: {},
            alertShow: false,            
            resMessage: '',
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true , soals:[], materi:{}, video: {} })
        const param = this.props.location.state;
        if(param.idProfil !== null) {
            if(this.state.tipeKonten === 'SOAL') {
                this.getKontenSoal(param.idProfil)
            }
            else if(this.state.tipeKonten === 'MATERI') {
                this.getKontenMateri(param.idProfil)
            }
            else if(this.state.tipeKonten === 'VIDEO') {
                this.getKontenVideo(param.idProfil)
            }
        } 
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';        
            if (window.opera) {script.innerHTML = config
            } else { script.text = config }
        
            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
            })        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
        this.setState({ isFetching: false })
    }    

    async getKontenSoal(id) {
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.LEARNING_GET_SOAL_PROFIL + id)
            .catch(function(error){console.log(error)});        
        if (result) {            
            this.setState({ isFetching: false , soals: result.data.data});
        }   
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);  
    }

    async getKontenMateri(id) {
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.LEARNING_GET_TEKS_PROFIL + id)
            .catch(function(error){console.log(error)});        
        if (result) {            
            this.setState({ isFetching: false , materi: result.data.data});
        }   
    }

    async getKontenVideo(id) {
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.LEARNING_GET_VIDEO_PROFIL + id)
            .catch(function(error){console.log(error)});        
        if (result) {            
            this.setState({ isFetching: false , video: result.data.data});
        }   
    }
    
    renderHeader() {        
        return (
            <Row>
                {/* <Col><h3>Learning {this.state.tipeKonten}</h3>  </Col>                     */}
                <Col >   
                    <div className="pull-right">   
                    <Button variant="outline-dark" id="btn-print" style={{width: '97px'}} onClick={() => { window.print() }}>
                        Print</Button>      &nbsp;                
                    <Button variant="outline-danger " id="btn-keluar" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack() }}>
                        Keluar <i className="fa fa-arrow-right"></i></Button>   
                    </div>                            
                </Col>
            </Row>
        )
    }

    handleBack = () => {
        history.push({
            pathname: '/learning_konten/' + this.state.tipeKonten,
            state: this.state.data
        })
    }

    editKonten = () => { 
        const {tipeKonten} = this.state;
        if(tipeKonten === 'SOAL') {       
            history.push({
                pathname: '/mgtlearningsoal',
                state: {...this.state.data}
            })
        } 
        else if(tipeKonten === 'MATERI') {
            history.push({
                pathname: '/mgtlearningteks',
                state: {...this.state.data}
            })
        } 
        else if(tipeKonten === 'VIDEO') {
            history.push({
                pathname: '/mgtlearningvideo',
                state: {...this.state.data}
            })
        } 
    }

    handleSubmit = async() => {   
        if (window.confirm('Konfirmasi Simpan ?')) {
            this.setState({isFetching: true, alertShow: false});
            let {data, video, materi, soals} = this.state;          
            
            const response = await accountManagement.post(CONFIG.LEARNING_POST_PEMB_LATIHAN, {...LearningContentReq,
                idKelas: data.idKelas,
                idMapel: data.idMapel,
                idBab: data.idBab,
                idSubBab: data.idSubBab,
                idTematik: data.idTematik,
                idSubTematik: data.idSubTematik,
                idPembTematik: data.idPembTematik,
                idRencana: data.idRencana,
                tipeKontent: this.state.tipeKonten,
                owner: 'GURU',
                idMateri: materi.idMateriPelajaran, 
                idVideo: video.idVideo,
                soal_list: soals.map(v => v.idBankSoal),
                judul: data.judul
            }).catch(function(error){ console.log(error) });        
            
            if(response) {
                if(response.data.code === '200'){
                    let url = '';
                    if(this.state.tipeKonten === 'MATERI') {url = '/learning_konten/MATERI/'}
                    if(this.state.tipeKonten === 'VIDEO') {url = '/learning_konten/VIDEO/'}
                    if(this.state.tipeKonten === 'SOAL') {url = '/learning_konten/SOAL/'}
                    history.push({
                        pathname: url,
                        state: this.state.data
                    })                              
                } else {
                    this.setState({
                        alertShow: true,
                        resMessage: response.data.msg
                    })                
                }
                this.setState({isFetching: false});            
            }
            
        }
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 
    

    render() {
        const {tipeKonten, soals, materi} = this.state;   
        const style = {
            position: 'fixed',
            bottom: '-5px',
            backgroundColor: '#fafafa',
            margin: '0px 0px 45px -30px',
            width: '100%'
        };
        if(tipeKonten === 'SOAL') {
            return (
                <div className="container-fluid" style={{ marginTop: '20px' }}>   
                    <>                 
                    <LoaderModal isFetching={this.state.isFetching} />
                    {this.renderHeader()}
                    {this.loadAlert()} 
                    <Col className="text-center"><h4>{this.state.data.judul}</h4></Col>
                    <table className="table">
                        <tbody>
                        {soals.map((soal,i) => 
                            (soal.tipeSoal === 'MULTIPLE' &&
                            <tr key={soal.idBankSoal}>
                                <td><p>{i+1}.</p></td>
                                <td>                                                                     
                                    <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>                                
                                    <table className="table">
                                        <tbody>
                                        <tr style={{backgroundColor: soal.kunciJawaban == "1" ? "#a3fffb": ""}} >
                                            <td width="10px"><p>A.</p></td>
                                            <td dangerouslySetInnerHTML={{__html: soal.jawab1}}></td>
                                        </tr>
                                        <tr style={{backgroundColor: soal.kunciJawaban == "2" ? "#a3fffb": ""}} >
                                            <td><p>B.</p></td>
                                            <td dangerouslySetInnerHTML={{__html: soal.jawab2}}></td>
                                        </tr>
                                        <tr style={{backgroundColor: soal.kunciJawaban == "3" ? "#a3fffb": ""}} >
                                            <td><p>C.</p></td>
                                            <td dangerouslySetInnerHTML={{__html: soal.jawab3}}></td>
                                        </tr>
                                        <tr style={{backgroundColor: soal.kunciJawaban == "4" ? "#a3fffb": ""}} >
                                            <td><p>D.</p></td>
                                            <td dangerouslySetInnerHTML={{__html: soal.jawab4}}></td>
                                        </tr>
                                        <tr style={{backgroundColor: soal.kunciJawaban == "5" ? "#a3fffb": ""}} >
                                            <td><p>E.</p></td>
                                            <td dangerouslySetInnerHTML={{__html: soal.jawab5}}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                            <p>Pembahasan:</p>
                                            <span dangerouslySetInnerHTML={{__html: soal.isianJawaban}}></span>
                                            </td>
                                        </tr>
                                        </tbody>   
                                    </table>                                
                                </td>                                  
                            </tr>
                            )
                        )}   
                        </tbody>
                    </table>
                    </>

                    {this.state.data.owner === 'PRIME' && 
                    <div style={style}>
                        <Row> 
                            <Col>                                
                                <Button type="submit" variant="primary pull-right"
                                onClick={() => this.handleSubmit()} >
                                Simpan </Button>  &nbsp;

                                <Button type="button" variant="warning pull-right" 
                                onClick={() => this.editKonten()} style={{width: '100px', marginRight:'10px'}}>
                                Edit </Button> &nbsp;
                            </Col> 
                        </Row> 
                    </div>
                    }
                </div>
            )
        }     
        else if(tipeKonten === 'MATERI') { 
            return (
                <div className="container-fluid" style={{ marginTop: '20px' }}>
                    <>
                    <LoaderModal isFetching={this.state.isFetching} />
                    {this.renderHeader()}
                    {this.loadAlert()} 
                    <Col className="text-center"><h4>{this.state.data.judul}</h4></Col>
                    <Col>
                        <span dangerouslySetInnerHTML={{__html: materi.isiMateri}}></span>    
                    </Col>
                    </>
                    {this.state.data.owner === 'PRIME' && 
                    <div style={style}>
                        <Row> 
                            <Col>                                
                                <Button type="submit" variant="primary pull-right"
                                onClick={() => this.handleSubmit()} >
                                Simpan </Button>  &nbsp;

                                <Button type="button" variant="warning pull-right" 
                                onClick={() => this.editKonten()} style={{width: '100px', marginRight:'10px'}}>
                                Edit </Button> &nbsp;
                            </Col> 
                        </Row> 
                    </div>
                    }
                </div>
            )    
        }
        else if(tipeKonten === 'VIDEO') { 
            return (
                <div className="container-fluid" style={{ marginTop: '20px' }}>
                    <>
                    <LoaderModal isFetching={this.state.isFetching} />
                    {this.renderHeader()}
                    {this.loadAlert()} 
                    <Col className="text-center"><h4>{this.state.data.judul}</h4></Col>
                    
                    <Col className="text-center">                                       
                        <ReactPlayer style={{margin: 'auto'}}
                            url={this.state.video.linkVideo} 
                            controls
                        />
                    </Col>
                    </>

                    {this.state.data.owner === 'PRIME' && 
                    <div style={style}>
                        <Row> 
                            <Col>                                
                                <Button type="submit" variant="primary pull-right" onClick={() => this.handleSubmit()}>
                                Simpan</Button>  &nbsp;

                                <Button type="button" variant="warning pull-right" 
                                onClick={() => this.editKonten()} style={{width: '100px', marginRight:'10px'}}>
                                Edit</Button> &nbsp;
                            </Col> 
                        </Row> 
                    </div>
                    }
                </div>
            ) 
        }
    }
}

export default ViewKonten;